import { combineReducers } from 'redux';
import { loginReducer } from '../components/account/Login/ducks/reducer';
import { customersReducer } from '../components/customers/CustomerList/ducks/reducer';
import { customerReducer } from '../components/customers/CustomerForm/ducks/reducer';
import { companiesReducer } from '../components/companies/CompanyList/ducks/reducer';
import { companyReducer } from '../components/companies/CompanyForm/ducks/reducer';
const rootReducer = combineReducers({
  loginReducer,
  customersReducer,
  customerReducer,
  companiesReducer,
  companyReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js